
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { getHrefForExternalLink } from "@/utils/externalLinkUtil"

@Component({
	components: {
	}
})
export default class ExternalLink extends Vue {
	@Prop({ default: "" })
	public value!: string;

	@Prop({ type: Boolean, default: false })
	public readonly!: Boolean;

	public stringValue: string | null = null;

	public mounted () {
		this.setValue(this.value)
	}

	@Watch("value")
	onValueChanged (newValue: any) {
		this.setValue(newValue)
	}

	setValue (newValue: any) {
		const oldValue = this.stringValue
		if (oldValue !== newValue) {
			this.stringValue = newValue
			this.$emit("input", newValue)
		}
	}

	blurValue (newValue: string) {
		this.$emit("blur", newValue)
	}

	private getHrefForExternalLink: (link: string | null) => string | null = getHrefForExternalLink
}
